module.exports = __webpack_public_path__ + "img/EventWinPage1002.aeb99260.jpg";